import { nextTick, onMounted, ref } from 'vue'
import { waitXSeconds } from '@lib/utils/utils'

const DIALOG_LEAVE_MS = 250 // matches fade-bottom transition duration

export function useDialogTransition() {
  const shown = ref(false)

  onMounted(async () => {
    await nextTick()
    shown.value = true
  })

  const closeDialog = (): Promise<void> => {
    shown.value = false
    return waitXSeconds(DIALOG_LEAVE_MS / 1000)
  }

  return { shown, closeDialog }
}
